import React from "react";
import LayerItem from "./LayerItem";
import Item from "../../layers/dto/Item";
import DataSetFilterItem from "../../filter/DataSetFilter/dto/DataSetFilterItem";

interface LayerGroupProps {
    id: string | number;
    className: string;
    children: DataSetFilterItem[];
    expanded: boolean;
    onExpand: (itemId: string, expand: boolean) => void;
    visible: boolean;
    onRemove: false | ((filterId: number) => void);
    onRowClick?: () => void;
    onHide: false | ((filterId: number, visibility: boolean) => void);
    nesting: number;
    onAdd?: (() => void) | null;
    onRefresh?: false | (() => void);
    item: Item;
}
const LayerGroup = (props: LayerGroupProps) => {
    const nesting = 15 * props.nesting;
    const children = props.children.map((item) =>
        item.group ? (
            <LayerGroup
                className={props.className}
                children={item.children}
                expanded={item.expanded}
                nesting={props.nesting + 1}
                onExpand={props.onExpand}
                onRemove={props.onRemove}
                onHide={props.onHide}
                visible={item.visibility}
                id={item.id}
                key={`group-${item.id}`}
                item={item}
            />
        ) : (
            <LayerItem
                key={props.id + item.id}
                className={props.className}
                itemVisible={item.visibility}
                onHide={props.onHide}
                onRemove={props.onRemove}
                onClick={props.onRowClick}
                item={item}
            />
        )
    );

    return (
        <div id={"group"}>
            <LayerItem
                className={`${props.className}`}
                itemVisible={props.visible}
                onHide={props.onHide}
                onExpand={props.onExpand}
                itemExpanded={props.expanded}
                onAdd={props.onAdd}
                onRemove={props.onRemove}
                onClick={null}
                onRefresh={props.onRefresh}
                item={props.item}
            ></LayerItem>
            {props.expanded ? <div style={{ marginLeft: nesting }}>{children}</div> : null}
        </div>
    );
};

export default LayerGroup;
